const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M126.7,119.8l-24.7-24.7c8.5-10.1,13.7-23.1,13.7-37.3,0-31.9-25.9-57.8-57.8-57.8S0,25.9,0,57.8s25.9,57.8,57.8,57.8c13.7,0,26.9-4.8,37.3-13.7l24.7,24.7c1.9,1.8,4.8,1.8,6.7,0,1.9-1.8,2-4.9.1-6.8h0ZM57.8,106c-26.6,0-48.2-21.6-48.2-48.2S31.2,9.6,57.8,9.6s48.2,21.6,48.2,48.2-21.6,48.2-48.2,48.2h0Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6,28.9c0,2.7-2.2,4.8-4.8,4.8-13.3,0-24.1,10.8-24.1,24.1s-2.2,4.8-4.8,4.8-4.8-2.2-4.8-4.8c0-9.3,3.8-17.7,9.9-23.8s14.5-9.9,23.8-9.9,2.5.5,3.4,1.4c.9.9,1.4,2.1,1.4,3.4h0,0Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d42b118a3bafbb0949f13d18ee8f806c.svg";
export { ForwardRef as ReactComponent };